import { mathConditionDefinition } from '../../../nodes/definitions/conditions/math-condition';
import type { FlowCardDefinition } from '../types';

const VERSION = '1.0.0';

export const mathConditionCard: FlowCardDefinition = {
	type: 'mathCondition',
	version: VERSION,
	domain: 'core',
	role: 'condition',
	category: 'conditions',
	label: 'Math Expression',
	description: 'Compare a calculation made from one or more device values',
	icon: 'fa-square-root-variable',
	color: '#8b5cf6',
	schema: {
		$schema: 'https://json-schema.org/draft/2020-12/schema',
		type: 'object',
		required: ['expression', 'params'],
		properties: {
			expression: { type: 'string', minLength: 1 },
			params: { type: 'array' },
			mathScript: { type: 'object' },
			sceneData: { type: 'object' },
			isValid: { type: 'boolean' },
		},
	},
	// The expression builder remains a typed editor extension, but its contract now belongs here.
	fields: [{ path: 'expression', label: 'Expression', type: 'math-configuration' }],
	ports: { sources: ['true', 'false'] },
	defaults: () => ({
		expression: '',
		params: [],
		mathScript: {},
		requiresConfiguration: true,
		cardVersion: VERSION,
	}),
	summary: (data) => {
		const expression = String(data.expression || data.sceneData?._gui_math_expression || '').trim();
		return expression ? `When ${expression}` : 'Build a math expression';
	},
	validate: (data) => {
		const expression = String(data.expression || data.sceneData?._gui_math_expression || '').trim();
		const params = Array.isArray(data.params)
			? data.params
			: Array.isArray(data.sceneData?._gui_math_params)
				? data.sceneData._gui_math_params
				: [];
		const issues = [];
		if (!expression) issues.push({ path: 'expression', message: 'Enter a math expression' });
		if (!params.length)
			issues.push({ path: 'params', message: 'Add at least one device parameter' });
		if (data.isValid === false && !issues.length)
			issues.push({ path: 'expression', message: 'Fix the math expression' });
		return issues;
	},
	compile: (node, context) => {
		const compiled = mathConditionDefinition.toSceneJson(node, context);
		return compiled && typeof compiled === 'object'
			? {
					...compiled,
					_fid: (compiled as any)._fid || node.id,
					_flow_card: 'mathCondition',
					_flow_card_version: VERSION,
				}
			: compiled;
	},
	migrate: (data) => ({
		...data,
		expression: data.expression ?? (data.sceneData as any)?._gui_math_expression ?? '',
		params: Array.isArray(data.params)
			? data.params
			: Array.isArray((data.sceneData as any)?._gui_math_params)
				? (data.sceneData as any)._gui_math_params
				: [],
		mathScript: data.mathScript ?? (data.sceneData as any)?._gui_math_script ?? {},
	}),
};
